import React, { useState, useEffect } from 'react';

const DigitalClock = () => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    // Formatar data: "terça-feira, 23 de abril de 2024"
    const formatDate = (date) => {
        return date.toLocaleDateString('pt-BR', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    // Formatar hora: "10:15:30"
    const formatTime = (date) => {
        return date.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
    };

    return (
        <div
            className="d-flex flex-column justify-content-center align-items-center px-4 py-4 rounded shadow-sm border border-secondary bg-dark bg-opacity-50 me-3 gap-1"
            style={{ backdropFilter: 'blur(5px)', minWidth: '200px', minHeight: '100px' }}
        >
            <div className="text-info small text-uppercase fw-bold mb-0" style={{ fontSize: '0.75rem', letterSpacing: '1px' }}>
                {formatDate(time)}
            </div>
            <div className="text-white fw-bold font-monospace leading-none" style={{ fontSize: '1.75rem', lineHeight: '1' }}>
                {formatTime(time)}
            </div>
        </div>
    );
};

export default DigitalClock;
